import { createStyles, Theme } from '@material-ui/core'

export const styles = (theme: Theme) =>
  createStyles({
    tablesContainer: {
      marginTop: theme.spacing(1)
    },
    tableTitles: {
      marginBottom: theme.spacing(2),
      fontWeight: 'bold',
      opacity: 0.7
    },
    buttons: {
      marginBottom: theme.spacing(2),
      marginLeft: theme.spacing(2),
      textAlign: 'right'
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      backgroundColor: '#ffffff',
      color: theme.palette.secondary.main,
      borderBottom: '1px solid',
      borderBottomColor: theme.palette.grey[300],
      '& .MuiToolbar-gutters': {
        paddingLeft: theme.spacing(2)
      }
    }
  })
